const React = require("react");
const ButtonBack = require("../../../../dumb/Button/BackB");
const Caption = require("../../../../dumb/Caption/C");
const {backLocation, replaceLocation} = require("../../../../../router");

const FormApp = require('../FormApp');
const {apiV2AppCreate} = require("../../../../../api/merchant/application");
const {LINK_DEVELOPER_OPTIONS} = require("../../../../../constants/links");

module.exports = () => {

  const request = async (data) => apiV2AppCreate(data).then(() => {
    replaceLocation({
      path: LINK_DEVELOPER_OPTIONS,
    })
  });

  return (
    <div className="wmin270">
      <div className="layoutRow fhaS fvaC">
        <ButtonBack
          className="m-10 mr10"
          onClick={backLocation}
        />
        <Caption>Create New App</Caption>
      </div>
      <div className="mt35 wmax900 w@m">
        <FormApp
          request={request}
          resultText={[
            'App created',
            'We\'ve saved new app. Please return to app table and get your APP TOKEN'
          ]}
        />
      </div>
    </div>
  )
}